import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { showTradeOnApprovalBanner } from '../SbRespTradeOnApprovalPromo/SbRespTradeOnApprovalPromoBanner/sbRespTradeOnApprovalPromoHelpers';

const SbSharedTopTileControllerComponent = props => {
    const { searchBrowse, isUserTypeTrade, tradeOnApprovalBanner, priceTiles, viewer } = props;

    const showCategoryTiles = !get(searchBrowse, 'browseContentModule');
    const shouldShowPriceTiles =
        isUserTypeTrade &&
        !get(viewer, 'disablePriceTiles') &&
        get(searchBrowse, 'priceTiles.length') > 2;

    const appliedFilters = get(searchBrowse, 'appliedFilters') || [];
    const shouldShowTradeOnApprovalBanner =
        isUserTypeTrade &&
        get(viewer, 'onApprovalEnabled') &&
        showTradeOnApprovalBanner({ appliedFilters }) &&
        !!tradeOnApprovalBanner;

    let content = null;

    // price tiles are currently only on desktop
    if (priceTiles && shouldShowPriceTiles) {
        content = props.priceTiles;
    } else if (shouldShowTradeOnApprovalBanner) {
        content = props.tradeOnApprovalBanner;
    } else if (showCategoryTiles) {
        content = props.categoryTiles;
    }

    return content && <React.Fragment>{content}</React.Fragment>;
};

SbSharedTopTileControllerComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
    categoryTiles: PropTypes.node,
    tradeOnApprovalBanner: PropTypes.node,
    priceTiles: PropTypes.node,
    isUserTypeTrade: PropTypes.bool,
    viewer: PropTypes.object,
};

const mapStateToProps = state => {
    const { header } = state;
    return {
        isUserTypeTrade: header.isUserTypeTrade,
    };
};

export const SbSharedTopTileController = createFragmentContainer(
    connect(mapStateToProps)(SbSharedTopTileControllerComponent),
    {
        searchBrowse: graphql`
            fragment SbSharedTopTileController_searchBrowse on SearchBrowseQueryConnection {
                appliedFilters {
                    name
                    values {
                        code
                        urlLabel
                    }
                }
                priceTiles(isTrade: $isTrade) {
                    displayName
                }
                browseContentModule(contentModuleId: $contentModuleId) {
                    description
                }
            }
        `,
        viewer: graphql`
            fragment SbSharedTopTileController_viewer on Viewer {
                disablePriceTiles: isEnabled(key: "disablePriceTiles")
                onApprovalEnabled: isEnabled(key: "onApprovalEnabled")
            }
        `,
    }
);
